import { useId } from "react";
import { Search } from "lucide-react";

export function DataToolbar({ search, onSearchChange, searchPlaceholder = "Search...", searchLabel = "Search", filters = [], resultCount, itemLabel = "results" }) {
  const generatedId = useId();
  const searchId = `ops-search-${generatedId.replace(/:/g, "")}`;

  return (
    <div className="ops-toolbar">
      <div className="ops-toolbar-search">
        <Search size={15} aria-hidden="true" />
        <label className="sr-only" htmlFor={searchId}>{searchLabel}</label>
        <input
          id={searchId}
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
        />
      </div>
      {filters.map((filter) => (
        <select
          key={filter.label}
          className="ops-select ops-toolbar-filter"
          value={filter.value}
          onChange={(e) => filter.onChange(e.target.value)}
          aria-label={filter.label}
        >
          {filter.options.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      ))}
      {typeof resultCount === "number" && (
        <span className="ops-toolbar-count">{resultCount} {itemLabel}</span>
      )}
    </div>
  );
}
